import { config } from "@/shared/lib/config";
import type { LookupItem } from "@/shared/lib/utils";
import { fetchLookupForInfinite, hydrateLookupItem } from "@/shared/lib/utils";
import { InfiniteCombobox } from "@/shared/ui/InfiniteCombobox";
import type { SOPMappingQueryDTO } from "../../domain/contracts/mapping";

type SOPItem = LookupItem;
type PositionItem = LookupItem & {
  title?: string;
};
type DepartmentItem = LookupItem;

type SOPMappingFilterProps = {
  filters: Partial<SOPMappingQueryDTO>;
  onFiltersChange: (filters: Partial<SOPMappingQueryDTO>) => void;
};

export function SOPMappingFilter({
  filters,
  onFiltersChange,
}: SOPMappingFilterProps) {
  const hasFilters =
    !!filters.sopId || !!filters.positionId || !!filters.departmentId;

  return (
    <div className="flex flex-wrap items-center gap-4 border-b px-4 py-3">
      <div className="flex flex-1 flex-wrap items-center gap-4">
        <InfiniteCombobox<SOPItem>
          queryKey={["sops", "filter"]}
          queryFn={(args) =>
            fetchLookupForInfinite(`${config.apiUrl}/sop/lookup`, {
              search: args.search,
              pageParam: args.pageParam,
            })
          }
          preloadQueryFn={(id) =>
            hydrateLookupItem(`${config.apiUrl}/sop/lookup`, id)
          }
          className="max-w-xs"
          getLabel={(item) => item.name}
          getValue={(item) => item.id}
          value={filters.sopId || ""}
          onValueChange={(value) =>
            onFiltersChange({ ...filters, sopId: value || undefined })
          }
          placeholder="ກອງ SOP..."
          clearable
        />

        <InfiniteCombobox<PositionItem>
          queryKey={["positions", "filter"]}
          queryFn={(args) =>
            fetchLookupForInfinite(`${config.apiUrl}/positions/lookup`, {
              search: args.search,
              pageParam: args.pageParam,
            })
          }
          preloadQueryFn={(id) =>
            hydrateLookupItem(`${config.apiUrl}/positions/lookup`, id)
          }
          className="max-w-xs"
          getLabel={(item) => (item as PositionItem).title || item.name}
          getValue={(item) => item.id}
          value={filters.positionId || ""}
          onValueChange={(value) =>
            onFiltersChange({ ...filters, positionId: value || undefined })
          }
          placeholder="ກອງຕໍາແໜ່ງ..."
          clearable
        />

        <InfiniteCombobox<DepartmentItem>
          queryKey={["departments", "filter"]}
          queryFn={(args) =>
            fetchLookupForInfinite(`${config.apiUrl}/departments/lookup`, {
              search: args.search,
              pageParam: args.pageParam,
            })
          }
          preloadQueryFn={(id) =>
            hydrateLookupItem(`${config.apiUrl}/departments/lookup`, id)
          }
          className="max-w-xs"
          getLabel={(item) => item.name}
          getValue={(item) => item.id}
          value={filters.departmentId || ""}
          onValueChange={(value) =>
            onFiltersChange({ ...filters, departmentId: value || undefined })
          }
          placeholder="ກອງພະແນກ..."
          clearable
        />
      </div>

      {/* {hasFilters && (
        <Button variant="ghost" size="sm" onClick={() => onFiltersChange({})}>
          <X className="mr-2 h-4 w-4" />
          ລຶບການກອງ
        </Button>
      )} */}
    </div>
  );
}
